//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'ModalStats',
  data() {
    return {
    }
  },
  computed: {
    statId() {
      return this.$store.state.statId
    }
  },
  mounted() {
      //    this.$modal.show('modal-stats')

  },
  methods: {
    beforeOpen (event) {
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-stats')
    }
  }
}
